import React, { Component } from 'react';
// import { Link } from 'gatsby';
import QABg from 'src/components/service/bg.jpg';
import QABgText from 'src/components/service/bgText.png';
import styled from '@emotion/styled';
import Layout from 'src/layouts/default/default';
import QALeft from 'src/components/service/QALeft';
import QARight from 'src/components/service/QARight';

const Wrap = styled.div`
  position: relative;
  margin-bottom: 40px;
  ${'' /* border: 1px solid red; */}
`;

const Banner = styled.img`
  width: 100%;
`;

const BannerText = styled.img`
  ${'' /* width: 100%; */}
  position: absolute;
  top: 30%;
  left: 40%;
`;

const Container = styled.div`
  width: 90%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
  ${'' /* border: 1px solid red; */}
`;

export default class QA extends Component {
  componentDidMount() {}

  render() {
    return (
      <Layout
        title="商用清洁机器人_无人驾驶环卫车_无人扫地车-高仙机器人"
        keywords="无人驾驶环卫车_无人扫地车_无人清扫车_安防巡检机器人_SLAM_激光导航-高仙机器人"
      >
        <Wrap>
          <Banner src={QABg} alt="高仙问答" title="高仙问答" />
          <BannerText src={QABgText} alt="高仙问答" title="高仙问答" />
        </Wrap>
        <Container>
          <QALeft />
          <QARight />
        </Container>
      </Layout>
    );
  }
}
